"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _CanSpamSettings = require("lead-flows-ui/selectors/CanSpamSettings");

var BASE_URL = '/content/api/v4/can-spam-settings';
var _default = {
  fetchCanSpamSettings: function fetchCanSpamSettings() {
    return _apiClient.default.get(BASE_URL);
  },
  updateCanSpamSettings: function updateCanSpamSettings(canSpamSettings) {
    var address = (0, _CanSpamSettings.getDefaultAddress)(canSpamSettings);

    if (address.id) {
      return _apiClient.default.put(BASE_URL + "/" + address.id, {
        data: address
      });
    }

    return _apiClient.default.post(BASE_URL, {
      data: canSpamSettings.objects[0]
    });
  }
};
exports.default = _default;
module.exports = exports.default;